
import Vue from 'vue'
import {Component, Watch} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseCardContainer from '@/containers/base/BaseCardContainer.vue'
import SujetForm from '@/components/forms/MailSujetForm.vue'
import VueScrollTo from 'vue-scrollto'

const mailModule = namespace('mail')

@Component({
  components: {
    BaseCardContainer,
    SujetForm
  }
})
export default class SujetUpdate extends Vue {
  @mailModule.Action('getMailSujetByIdAction') getMailSujetById: any
  @mailModule.Action('getMailSujetsAction') getMailSujets: any
  @mailModule.Action('updateMailSujetAction') updateMailSujet: any
  @mailModule.Getter('mailSujetGetter') mailSujet: any

  mounted() {
    this.getMailSujetById(this.$route.params.id)
    this.$nextTick(() => VueScrollTo.scrollTo('#form'))
  }

  @Watch('$route.params.id', {immediate: true, deep: false})
  onUrlChange(newVal: any) {
    this.getMailSujetById(newVal)
  }

  onSubmit(data: any) {
    this.updateMailSujet({
      id: this.$route.params.id,
      formParams: data
    }).then(async (data: any) => {
      await this.getMailSujets()
      this.$router.push({name: 'SujetList'})
    })
  }

  onCancel() {
    this.$router.push({name: 'SujetList'})
  }
}
